import * as React from 'react';
import {FunctionComponent} from 'react';
import {ResultPercentage} from './result_percentage';

interface OwnProps {
    previous: number;
    next: number;
}

export const GrowthPercentage: FunctionComponent<OwnProps> = ({previous, next}) => {
    return <ResultPercentage factor={(next - previous) / previous} />;
};
